// src/features/menu/screens/MenuPage.tsx

import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaLinkedin, FaInstagram } from 'react-icons/fa';
import { SiUpwork } from 'react-icons/si';
import { motion } from 'framer-motion';
import styles from './MenuPage.module.scss';

const menuVariants = {
  hidden: {},
  visible: {
    transition: {
      when: 'beforeChildren',
      staggerChildren: 0.1,
    },
  },
  exit: {
    transition: {
      when: 'afterChildren',
      staggerChildren: 0.1,
      staggerDirection: -1,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 20 },
};

const MenuPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.menuPage}>
      <motion.nav
        className={styles.menuNav}
        variants={menuVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
        <motion.ul>
          <motion.li variants={itemVariants}>
            <NavLink to="/">
              {t('navigation.home')}
            </NavLink>
          </motion.li>
          <motion.li variants={itemVariants}>
            <NavLink to="/projects">
              {t('navigation.projects')}
            </NavLink>
          </motion.li>
          <motion.li variants={itemVariants}>
            <NavLink to="/contact">
              {t('navigation.contact')}
            </NavLink>
          </motion.li>
        </motion.ul>

        <motion.div className={styles.socialLinks}>
          <motion.a
            href="https://linkedin.com/in/jamiljoo"
            target="_blank"
            rel="noopener noreferrer"
            variants={itemVariants}
          >
            <FaLinkedin />
          </motion.a>
          <motion.a
            href="https://www.instagram.com/jamil_joo/"
            target="_blank"
            rel="noopener noreferrer"
            variants={itemVariants}
          >
            <FaInstagram />
          </motion.a>
          <motion.a
            href="https://www.upwork.com/freelancers/~011243a6d19af75131"
            target="_blank"
            rel="noopener noreferrer"
            variants={itemVariants}
          >
            <SiUpwork />
          </motion.a>
        </motion.div>
      </motion.nav>
    </div>
  );
};

export default MenuPage;